const CAMPAIGN_STATE = {
  UNDER_CONSTRUCTION: 'under_construction', // The campaign is still being built
  DRAFT: 'draft', // The draft for the Campaign is being built by the Brand/Agency
  UNDER_REVIEW: 'under_review', // The draft of the Campaign has been submitted for review by a CSM
  APPROVED: 'approved', // This campaign is approved and ready to launch when subscribed
  ACCEPTING_PROPOSALS: 'accepting_proposals', // This campaign is open to applications
  CLOSED_TO_NEW_PROPOSALS: 'closed_to_new_proposals', // This campaign was hidden by an admin
  CLOSED: 'closed', // This campaign has reached its goal and cannot receive or accept more applications
};

export default CAMPAIGN_STATE;
